var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    transform: "translate(-495 -249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_x_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/x][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    width: 20,
    height: 20,
    transform: "translate(495 249)",
    fill: "rgba(253,73,198,0.35)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-grip-lines",
    "data-name": "Icon awesome-grip-lines",
    d: "M16.884,15.607H.545A.546.546,0,0,0,0,16.152v1.089a.546.546,0,0,0,.545.545H16.884a.546.546,0,0,0,.545-.545V16.152A.546.546,0,0,0,16.884,15.607Zm0-4.357H.545A.546.546,0,0,0,0,11.795v1.089a.546.546,0,0,0,.545.545H16.884a.546.546,0,0,0,.545-.545V11.795A.546.546,0,0,0,16.884,11.25Z",
    transform: "translate(496.5 244.75)",
    fill: "#897f7f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.a6cd8ff8b2de62f47fc5bad111c9179a.svg";
export { ForwardRef as ReactComponent };